export type RiftLadder = {
  playerIndex: number
  opponents: number[]
}

function normalizeIndex(index:number,count:number){
  return ((index%count)+count)%count
}

/**
 * Builds a deterministic CPU ladder from the existing roster.
 * Every other fighter appears exactly once, beginning with the next roster slot
 * and wrapping around so selecting a different player also changes the run.
 */
export function buildRiftLadder(playerIndex:number,fighterCount:number):RiftLadder{
  if(!Number.isSafeInteger(fighterCount)||fighterCount<2)throw new Error('Rift ladder requires at least two safe-integer fighters')
  if(!Number.isSafeInteger(playerIndex))throw new Error('Rift ladder player index must be a safe integer')
  const player=normalizeIndex(playerIndex,fighterCount)
  return{
    playerIndex:player,
    opponents:Array.from({length:fighterCount-1},(_,offset)=>(player+offset+1)%fighterCount),
  }
}

export function nextRiftStage(stageIndex:number,totalStages:number):number|null{
  if(!Number.isSafeInteger(stageIndex)||stageIndex<0)throw new Error('Invalid rift ladder stage index')
  if(!Number.isSafeInteger(totalStages)||totalStages<1)throw new Error('Invalid rift ladder stage count')
  if(stageIndex>=totalStages)throw new Error('Rift ladder stage index is outside the run')
  const next=stageIndex+1
  return next<totalStages?next:null
}
